/**
 *
 * Company
 * @class Company
 */

export class Company {

    /**
     * Creates an instance of Company.
     * @param { CompanyObj } companyObj
     * @memberof Company
     */

    constructor(companyObj) {
        if(typeof companyObj === 'undefined' || companyObj === null){
            companyObj = {}
        }

        this.id                 = companyObj.id || null
        this.name               = companyObj.name || null
        this.business_name      = companyObj.business_name || null
        this.email              = companyObj.email || null
        this.nif                = companyObj.nif || null
        this.financial_email    = companyObj.financial_email || null
        this.zipcode            = companyObj.zipcode || null
        this.number             = companyObj.number || null
        this.street             = companyObj.street || null
        this.complement         = companyObj.complement || null
        this.district           = companyObj.district || null
        this.city               = companyObj.city || null
        this.uf                 = companyObj.uf || null
    }

    /**
     * Creates an instance of Company.
     * @param { CompanyObj } companyObj
     * @memberof Company
     * @returns { Company }
     */
    static init(companyObj) {
        return new Company(companyObj)
    }

}
